/* HALO: show line item properties (e.g. the two device colours) in the cart drawer. */
customElements.whenDefined('wly-cart-drawer').then(() => {
  const Drawer = customElements.get('wly-cart-drawer');
  if (!Drawer || Drawer.prototype.__haloPatched) return;
  const original = Drawer.prototype.lineHTML;
  Drawer.prototype.lineHTML = function (item, index) {
    let html = original.call(this, item, index);
    const props = Object.entries(item.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_');
    if (!props.length) return html;
    const opts = (item.options_with_values || [])
      .filter((o) => !/^colou?r$/i.test(o.name))
      .map((o) => `${this.escape(o.name)}: ${this.escape(o.value)}`);
    const extra = props.map(([k, v]) => `${this.escape(k)}: ${this.escape(v)}`);
    const line = `<p class="wly-cart__item-opts">${opts.concat(extra).join(' &middot; ')}</p>`;
    if (/<p class="wly-cart__item-opts">[\s\S]*?<\/p>/.test(html)) {
      html = html.replace(/<p class="wly-cart__item-opts">[\s\S]*?<\/p>/, line);
    } else {
      html = html.replace(/(<a class="wly-cart__item-name"[\s\S]*?<\/a>)/, `$1${line}`);
    }
    return html;
  };
  Drawer.prototype.__haloPatched = true;
  document.querySelectorAll('wly-cart-drawer').forEach((el) => { if (el.cart) el.render(); });
});
